module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Status/images/past_left_2.645c1c98.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Status/images/past_left_2.png
// module id = 2868
// module chunks = 11